export const CLIENT_GET_REQUEST = 'CLIENT_GET_REQUEST'
export const CLIENT_GET_SUCCESS = 'CLIENT_GET_SUCCESS'
export const CLIENT_GET_ERROR = 'CLIENT_GET_ERROR'

export const CLIENT_DELETE_REQUEST = 'CLIENT_DELETE_REQUEST'
export const CLIENT_DELETE_SUCCESS = 'CLIENT_DELETE_SUCCESS'
export const CLIENT_DELETE_ERROR = 'CLIENT_DELETE_ERROR'
